import { tryParseJson } from '../json';

export const getAeoGroupingId = (referrerDecodeInfo: string) => {
	const { source, ad_channel, ad_info } = tryParseJson(referrerDecodeInfo) ?? {};
	if (source === 'ad' && ad_channel === 'meta') {
		const regex = /"campaign_group_id":\s*(\d+)/;
		const match = ad_info.match(regex);
		if (match && match.length > 1) {
			return match[1] as string;
		}
	}
	return '';
};
